import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import store from '@/store';
import urls from '@/urls';

const env = {
  'prod' : 'https://login.allplan.com/realms/allplan',
  'stage': 'https://login-stage.allplan.com/realms/allplan'
};

const clientId = {
  'prod' : 'ext-manufacton-p-ath-m4q8jvnz1wt6khr5',
  'stage': 'ext-manufacton-s-ath-a9x3vplz7wtykh2c'
};

const oidcConfig = {
  authority: env[urls.bimplusEnvironment],
  client_id: clientId[urls.bimplusEnvironment],
  redirect_uri: `${urls.bimplusRedirectUri}/api/v4/bimplus/redirect`,
  silent_redirect_uri: urls.bimplusRedirectUri,
  response_type: 'code',
  automaticSilentRenew: true,
  useRefreshTokens: true,
  scope: 'openid profile email',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

const userManager = new UserManager(oidcConfig);

userManager.events.addAccessTokenExpiring(async () => {
  console.log('Token is about to expire, attempting silent renew...');
  await store.restored;
  try {
    const userDetails = await userManager.signinSilent();
    if(userDetails !== null && userDetails.access_token !== '') {
      console.log('Token refreshed silently.');
      store.commit('setBimPlusDetails', userDetails);
    }
  } catch (err) {
    console.error('Silent renew failed:', err);
    store.commit('setBimPlusDetails', { access_token : '',
                                        refresh_token : '',
                                        expires_at : '',
                                        token_type : '',
                                        refresherror : true
    });
  }
});

// userManager.events.addUserLoaded((userDetails) => {
//   if(userDetails && userDetails.access_token) {
//     store.commit('setBimPlusDetails', userDetails);
//   }
// });

export default userManager;
